import { useContext, useMemo } from "react";
import { InternationalizationContext } from "../../../src/i18n/InternationalizationContext";
import * as translations from "./translations.json";

export interface PortraitsTranslator {
  (key: keyof (typeof translations)[keyof typeof translations]): string;
}

const translate =
  (language: keyof typeof translations) =>
  (key: keyof (typeof translations)[typeof language]) =>
    translations[language][key];

export const usePortraitsTranslator = (): PortraitsTranslator => {
  const { language } = useContext(InternationalizationContext);

  return useMemo(() => translate(language), [language]);
};
